var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZapActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6261 2.52846C12.8389 0.126424 16.7534 2.4893 15.659 5.56644L14.4886 8.85717H18.1525C20.7664 8.85717 22.13 11.9674 20.359 13.8898L13.3742 21.4715C11.1613 23.8736 7.24681 21.5107 8.34127 18.4335L9.51167 15.1429H5.84772C3.23386 15.1429 1.87027 12.0326 3.64131 10.1102L10.6261 2.52846ZM13.7746 4.89623C14.1395 3.87051 12.8346 3.0829 12.097 3.88357L5.11225 11.4653C4.52191 12.1061 4.97643 13.1429 5.84772 13.1429H10.9287C11.2537 13.1429 11.5584 13.3008 11.7458 13.5663C11.9331 13.8318 11.9798 14.1718 11.8709 14.478L10.2256 19.1038C9.86081 20.1295 11.1656 20.9171 11.9033 20.1164L18.888 12.5347C19.4784 11.8939 19.0238 10.8572 18.1525 10.8572H13.0716C12.7466 10.8572 12.4419 10.6993 12.2545 10.4338C12.0672 10.1682 12.0205 9.82824 12.1294 9.52207L13.7746 4.89623Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZapActive);
export default __webpack_public_path__ + "static/media/zap-active.73e4cd849abbb91279d915ec8c72fce2.svg";
export { ForwardRef as ReactComponent };